import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PbsManufacturesApi } from "apis/PbsManufacturesApi";
import { ProductsPbsManufacturerSearchFilterQuery } from "models/filters/products/ProductsPbsManufacturerSearchFilterQuery";
import { ProductPbsManufacturer } from "models/dbModels/products/ProductPbsManufacturer";
import { ManagedManufacturersApi } from "apis/ManagedManufacturersApi";
import { ManagedManufacturer } from "models/dbModels/managedManufacturers/ManagedManufacturer";

export const getPbsManufacturers = createAsyncThunk("manufacturersSlice/getManufacturers", async (params?: ProductsPbsManufacturerSearchFilterQuery) => { 
    const response = await PbsManufacturesApi.Search(params ?? {});
    return response.data;
});

type InitialStateType = {
    selectedRows: any[];
    deselectedRows: any[];
    loading: boolean;
    selectAllFilter: boolean;
    keyword: string;
    totalRows: number;
    totalPages: number;
    pageIndex: number;
    pageSize: number;
    error: string;
    table: ProductPbsManufacturer[];
}

const initialState: InitialStateType = {
    selectedRows: [],
    deselectedRows: [],
    loading: false,
    selectAllFilter: false,
    keyword: "",
    totalRows: 0,
    totalPages: 0,
    pageIndex: 0,
    pageSize: 100,
    error: "",
    table: [],
}

const storesTablesSlice = createSlice({
    name: "pbsManufacturersSlice",
    initialState : {
        ...initialState,
    },
    reducers: {
        cleanPbsManufacturersDetails: (state) => {
            return {
                ...state,
                ...initialState,
            };
        },
        updateManufacturersField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        addSelectedRows: (state, action) => {
            // @ts-ignore
           state.selectedRows[action.payload.index] = action.payload.rows;                 
        },
        addDeselectedRows: (state, action) => {
            // @ts-ignore
            state.deselectedRows[action.payload.index] = action.payload.rows;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getPbsManufacturers.fulfilled, (state, action) => {
            state.table = action.payload.data ? action.payload.data : [];
            state.totalRows = action.payload.totalRows;
            state.totalPages = Math.ceil(Math.ceil(action.payload.totalRows) / state.pageSize);
            state.loading = false;
        });
        builder.addCase(getPbsManufacturers.pending, (state) => {
            state.loading = true;
            state.table = [];
            state.error = "";
        });
        builder.addCase(getPbsManufacturers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || "";
        });
    },
});

export const getStoreGroupsTable = createAsyncThunk("manufacturersSlice/getManufacturer", async () => {
    const response = await ManagedManufacturersApi.Search({});
    return response.data;
});

export const getManufacturerDetails = createAsyncThunk("manufacturerSlice/getManufacturerDetails", async (manufacturerIds: number[]) => {
    const response = await ManagedManufacturersApi.Search({ ids: manufacturerIds });
    return response.data;
});

export const createManufacturer = createAsyncThunk("manufacturerSlice/updateManufacturer", async (manufacturer: ManagedManufacturer) => {
    const response = await ManagedManufacturersApi.Add([manufacturer]);
    return response.data;
});

export const createManufacturers = createAsyncThunk("manufacturerSlice/createManufacturers", async (manufacturer: ManagedManufacturer[]) => {
    const response = await ManagedManufacturersApi.Add(manufacturer);
    return response.data;
});

export const updateManufacturer = createAsyncThunk("manufacturerSlice/updateManufacturer", async (manufacturer: ManagedManufacturer) => {
    const response = await ManagedManufacturersApi.Update([manufacturer]);
    return response.data;
});

export const updateManufacturers = createAsyncThunk("manufacturerSlice/updateManufacturers", async (manufacturer: ManagedManufacturer[]) => {
    const response = await ManagedManufacturersApi.Update(manufacturer);
    return response.data;
});

export const { addDeselectedRows, addSelectedRows, cleanPbsManufacturersDetails, updateManufacturersField } = storesTablesSlice.actions;

export default storesTablesSlice.reducer;

